module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.8369/images/blonde-shelley/blonde-shelley@2x.png"